import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import {
  getComments,
  createComment as createCommentAPI,
  updateComment as updateCommentAPI,
  deleteComment as deleteCommentAPI,
} from '../../services';
import { displayNotification, checkOnline, getNotification } from '../notifications';
import {
  FETCH_COMMENTS,
  CREATE_COMMENT,
  UPDATE_COMMENT,
  DELETE_COMMENT,
  receiveComments,
  fetchComments,
} from './actions';

export function* doFetchComments(action) {
  const { parentId } = action;
  try {
    const { values: comments } = yield call(getComments, { parentId });
    yield put(receiveComments({ parentId, comments: comments.toReversed() }));
  } catch (error) {
    console.error('Unable to fetch comments:', error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('getComments', 'error')()));
  }
}

export function* doCreateComment(action) {
  const { commentData } = action;
  try {
    yield call(createCommentAPI, commentData);
    // Refresh comments after creating
    yield put(fetchComments({ parentId: commentData.parentId }));
  } catch (error) {
    console.error('Unable to create comment:', error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('createComment', 'error')()));
  }
}

export function* doUpdateComment(action) {
  const { commentId, commentData } = action;
  try {
    yield call(updateCommentAPI, commentId, commentData);
    // Refresh comments after updating
    yield put(fetchComments({ parentId: commentData.parentId }));
  } catch (error) {
    console.error('Unable to update comment:', error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('updateComment', 'error')()));
  }
}

export function* doDeleteComment(action) {
  const { commentId, parentId } = action;
  try {
    yield call(deleteCommentAPI, commentId);
    // Refresh comments after deleting
    yield put(fetchComments({ parentId }));
  } catch (error) {
    console.error('Unable to delete comment:', error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('deleteComment', 'error')()));
  }
}

export const sagas = [
  takeEvery(FETCH_COMMENTS, doFetchComments),
  takeLatest(CREATE_COMMENT, doCreateComment),
  takeLatest(UPDATE_COMMENT, doUpdateComment),
  takeLatest(DELETE_COMMENT, doDeleteComment),
];
